<template>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-sm-4">{{action}}:</label>
      <div class="col-sm-8">
        <multiselect
            @open="getOptions(action)"
            @input="updateProp"
            :ref="`multiselect-${resource}`"
            v-model="selection"
            :options="selection.find((i) => { return i.value === 'all'}) ? selection : options"
            placeholder="Bitte wählen Sie eine Option"
            :multiple="true"
            :hideSelected="true"
            :loading="isLoading"
            track-by="id"
            label="value"
        ></multiselect>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/services/Api'
  export default {
    props: ['action', 'resource'],
    name: "ResourceRow",
    data () {
      return {
        options: [],
        selection: [],
        isLoading: false
      }
    },
    methods: {
      getOptions (action) {
        this.isLoading = true
        Api().get(`/frontend/permission/${this.resource}?action=${action}`)
          .then(response => {
            this.isLoading = false
            this.options = response.data
          })
      },
      updateProp (event) {
       // this.$emit('select', {key: this.resource, action: this.action, values: this.selection})
        let props = []
        this.selection.forEach(x => {
          props.push(x.id)
        })
        this.$emit('select', {props: props, resource: this.resource, action: this.action} )
      }
    }
  }
</script>

<style scoped>

</style>
